import { DefaultTheme } from 'styled-components'

import typography from './typography'

const Theme: DefaultTheme = {
  typography,

  font: {
    primary: `'Roboto'`,
    secondary: `'Roboto'`,
    light: `'Roboto'`,
    normal: `'Roboto'`,
    medium: `'Roboto'`,
    semibold: `'Roboto'`,
    bold: `'Roboto'`,
    extrabold: `'Roboto'`,
  },

  font_size: {
    xxxsmall: 'font-size: 12px;',
    xxsmall: 'font-size: 14px;',
    xsmall: 'font-size: 16px;',
    small: 'font-size: 17px;',
    regular: 'font-size: 22px; line-height: 30px;',
    large: 'font-size: 28px; line-height: 30px;',
    larger: 'font-size: 40px; line-height: 50px;',
    xlarge: 'font-size: 48px; line-height: 48px;',
  },

  color: {
    primary: '#1976D2',
    secondary: '#1E88E5',
    accent: '#cca86e',
    background: {
      white: '#ffffff',
      light: '#f8f8f8',
    },
    white: {
      regular: '#ffffff',
      lessdark: '#faf9f8',
      dark: '#f6f6f6',
      darker: '#eeeeee',
    },
    black: {
      lightest: '#ABA8AF',
      light: '#564F62',
      regular: 'rgba(0, 0, 0, 0.54);',
    },
    text: 'rgba(0, 0, 0, 0.54);',
    text_primary: 'rgba(0, 0, 0, 0.87);',
    text_disabled: 'rgba(0, 0, 0, 0.38)',
    primary_light: '#A6D7FF',
  },
  screen: {
    xs: '575px',
    sm: '767px',
    md: '991px',
    lg: '1199px',
  },
}

export default Theme
